import { PadMarginCenterCombinedProps } from './types';

const usePresenter = (props: PadMarginCenterCombinedProps): PadMarginCenterCombinedProps => {
  return props;
};

export default usePresenter;
